<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getChangepkgGroupListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="getChangepkgGroupListHandler">查询</el-button>
                <el-button type="success" plain icon="el-icon-edit" @click="showChgPkgGroup">批量改套餐组</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" 
			border
			fit
			highlight-current-row
			style="width: 100%;"
			:header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column type="index" label="序号" align="center"></el-table-column>      
            <el-table-column label="ICCID号" width="160" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号" align="center"></el-table-column>
            <el-table-column prop="oldPkgGroupName" label="原套餐组名称" align="center"></el-table-column>
            <el-table-column prop="newPkgGroupName" label="新套餐组名称" align="center"></el-table-column>
            <el-table-column prop="createTime" label="操作时间" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" align="center"></el-table-column>
            <el-table-column prop="createOptName" label="操作人" align="center"></el-table-column>>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
			background
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true"  title="变更套餐组" :visible.sync="chgPkgGroupVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="chgPkgGroupForm" :model="chgPkgGroupForm" :rules="chgPkgGroupRules" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/change/pkgGroup/list')" :headers="setHeader()" :limit="1" :auto-upload="false" :data="chgPkgGroupForm" :on-change="handleChange" :on-success = "handleSuccess">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=changePkg')">导出模板</el-button>
                    </el-upload>                        
                </el-form-item>
                <el-form-item label="新套餐组名称：" prop="basePkgGroup">
                    <el-select v-model="chgPkgGroupForm.basePkgGroup" filterable>
                        <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="chgPkgGroupForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureChgPkgGroupHandler">确 定</el-button>
            </div> 
        </el-dialog>           
    </div>
</template>
<script>
import {getChangepkgGroupList} from '@/api/record.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            chgPkgGroupVisible: false,
            pkgGroup: [],
            chgPkgGroupForm: {
                basePkgGroup: '',
                remark: ''
            },
            chgPkgGroupRules: {
                basePkgGroup: [{required: true, message: '请选择要变更的套餐组', trigger: 'change'}]
            }
        }
    },
    methods: {
        cancel(){
            this.chgPkgGroupVisible = false; 
            this.$refs.chgPkgGroupForm.resetFields();
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getChangepkgGroupListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);   
            getChangepkgGroupList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })      
        },
        showChgPkgGroup(){
            this.chgPkgGroupVisible = true;
            common.getPkgGroupListCom(this, 'pkgGroup');
        },
        sureChgPkgGroupHandler(){
            this.$refs.chgPkgGroupForm.validate(valid => {
                if(valid){
                    this.$refs.upload.submit();
                }
            })
        },
        handleChange(file, fileList){
            if(fileList.length > 0){
                this.$refs.chgPkgGroupForm.fields[0].clearValidate();
            }
        },        
        handleSuccess(res){
            if(res.code == 200){
                this.chgPkgGroupVisible = false;
                this.getChangepkgGroupListHandler();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },        
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getChangepkgGroupListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getChangepkgGroupListHandler();
        }  
    },
    created () {
        this.getChangepkgGroupListHandler()
    }
}
</script>
<style lang="less" scoped>

</style>

